import { useMemo } from "react";

export default function useLeadOptions(leads = []) {
  /* SUBCATEGORY OPTIONS */
  const subCategoryOptions = useMemo(() => {
    const map = new Map();
    console.log("leads1", leads);
    leads.forEach((l) => {
      if (l.subCategoryName && l.subCategoryLabel) {
        map.set(l.subCategoryName.toLowerCase(), {
          label: l.subCategoryLabel,
          value: l.subCategoryName.toLowerCase(),
        });
      }
    });

    return Array.from(map.values());
  }, [leads]);

  /* LOCATION OPTIONS */
  const locationOptions = useMemo(() => {
    const map = new Map();

    leads.forEach((l) => {
      if (l.place) {
        map.set(l.place, {
          label: l.place,
          value: l.place,
        });
      }
    });

    return Array.from(map.values());
  }, [leads]);

  /* LAND TYPE OPTIONS */
  const landTypeOptions = useMemo(() => {
    const map = new Map();

    leads.forEach((l) => {
      if (l.landType) {
        map.set(l.landType, {
          label: l.landType,
          value: l.landType,
        });
      }
    });

    return Array.from(map.values());
  }, [leads]);

  /* BUDGET OPTIONS */
  const budgetOptions = useMemo(() => {
    const budgets = leads.map((l) => Number(l.price)).filter(Boolean);

    if (!budgets.length) return [];

    return [
      { label: "≤ 1 Cr", value: 10000000 },
      { label: "≤ 5 Cr", value: 50000000 },
      { label: "≤ 10 Cr", value: 100000000 },
    ];
  }, [leads]);

  /* PLOT SIZE OPTIONS */
  const plotSizeOptions = useMemo(() => {
    const sizes = leads.map((l) => Number(l.sqft)).filter((v) => v > 0);

    if (!sizes.length) return [];

    return [
      { label: "≥ 1000 sqft", value: 1000 },
      { label: "≥ 2000 sqft", value: 2000 },
      { label: "≥ 3000 sqft", value: 3000 },
    ];
  }, [leads]);

  return {
    subCategoryOptions,
    locationOptions,
    landTypeOptions,
    budgetOptions,
    plotSizeOptions,
  };
}
